export function getYouboraAccountCode(): string | null {
  const youboraAccountCode = process.env.GATSBY_YOUBORA_ACCOUNT_CODE;

  return youboraAccountCode ?? null;
}
